<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
 function loadrevSlider(){
    if($('#rev-slider').length> 0){
      $('#rev-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        prevArrow : '.rev-prev',
        nextArrow : '.rev-next',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow : 2,
              dots: true
            }
          }
        ]
      });
    }
  }


function showMoreFatcs() {
  $('.product-meta-drawer').addClass('show');
  $('.meta-background-overlay').addClass('show');
}

function closeMetaDrawer() {
  $('.product-meta-drawer').removeClass('show');
  $('.meta-background-overlay').removeClass('show');
}

function selectQuentity(elem, qty){
  $(elem).closest( ".volume-discount-tabel" ).find('.option-value-container').removeClass('selected-val');
  $(elem).addClass('selected-val');
  $('#volume-disc-qty' ).val(qty);
}

$(document).ready(function () {
  
  loadrevSlider();
});
 